import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const GOOGLE_FORM_ID = '1FAIpQLSftSUJDjJht0JQxpoe4Z_gPMqGDDUyG2St3Ti2m1koPNOKZyQ';
const GOOGLE_FORM_VIEW_URL = `https://docs.google.com/forms/d/e/${GOOGLE_FORM_ID}/viewform`;
const GOOGLE_FORM_EMBED_URL = `https://docs.google.com/forms/d/e/${GOOGLE_FORM_ID}/viewform?embedded=true`;

export const RSVPForm = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section ref={ref} className="py-20 bg-white" data-testid="rsvp-section">
      <div className="max-w-2xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }} className="text-center mb-10">
          <h2 className="font-serif text-4xl sm:text-5xl text-[#1A2B3D] mb-4">{t('rsvpTitle')}</h2>
          <div className="wave-divider mb-6" />
          <p className="text-[#6B8299]">{t('rsvpDesc')}</p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-[#EFF4F9] p-3 sm:p-4 rounded-sm overflow-hidden" data-testid="rsvp-form">
          <iframe
            src={GOOGLE_FORM_EMBED_URL}
            title="RSVP Google Form"
            className="w-full rounded-sm bg-white"
            style={{ height: '1400px', border: 'none' }}
            data-testid="rsvp-google-form-iframe"
          >
            Loading…
          </iframe>

          <div className="text-center mt-4">
            <a href={GOOGLE_FORM_VIEW_URL} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#1E3A5F] text-sm underline underline-offset-4 hover:text-[#C9A96E] transition-colors"
              data-testid="rsvp-open-form-link">
              {t('rsvpOpenFormNewTab')}
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
